var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPulse1X10S200Px200Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    style: {
      shapeRendering: "auto",
      display: "block",
      background: "transparent"
    },
    width: 200,
    height: 200,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#124076",
    height: 40,
    width: 15,
    y: 30,
    x: 17.5
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "-0.2s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    values: "18;30;30",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    dur: "1s",
    repeatCount: "indefinite",
    attributeName: "y"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "-0.2s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    values: "64;40;40",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    dur: "1s",
    repeatCount: "indefinite",
    attributeName: "height"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#f29100",
    height: 40,
    width: 15,
    y: 30,
    x: 42.5
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "-0.1s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    values: "20.999999999999996;30;30",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    dur: "1s",
    repeatCount: "indefinite",
    attributeName: "y"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "-0.1s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    values: "58.00000000000001;40;40",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    dur: "1s",
    repeatCount: "indefinite",
    attributeName: "height"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#124076",
    height: 40,
    width: 15,
    y: 30,
    x: 67.5
  }, /*#__PURE__*/React.createElement("animate", {
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    values: "20.999999999999996;30;30",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    dur: "1s",
    repeatCount: "indefinite",
    attributeName: "y"
  }), /*#__PURE__*/React.createElement("animate", {
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    values: "58.00000000000001;40;40",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    dur: "1s",
    repeatCount: "indefinite",
    attributeName: "height"
  })), /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulse1X10S200Px200Px);
export default __webpack_public_path__ + "static/media/Pulse@1x-1.0s-200px-200px.b56e6587974e564d57b2c332b755d5d1.svg";
export { ForwardRef as ReactComponent };